const prefix = process.env.VUE_APP_API_URL + 'typing/'

export const typingSingleLessonsAPI = prefix + 'typing-single-index'
export const typingCombineLessonsAPI = prefix + 'typing-combine-index'
export const typingOtherInformationAPI = prefix + 'typing-lesson-other-information'
export const typingSingleBasicLessonsAPI = prefix + 'typing-single-basic-lessons/'
export const typingSingleIntermediateLessonsAPI = prefix + 'typing-single-intermediate-lessons/'
export const typingSingleAdvancedLessonsAPI = prefix + 'typing-single-advanced-lessons/'
export const typingCombineIntermediateLessonsAPI = prefix + 'typing-combine-intermediate-lessons/'
export const typingCombineAdvancedLessonsAPI = prefix + 'typing-combine-advanced-lessons/'

export const typingSingleBasicLessonAPI = prefix + 'typing-single-basic-lesson/'
export const typingSingleIntermediateLessonAPI = prefix + 'typing-single-intermediate-lesson/'
export const typingSingleAdvancedLessonAPI = prefix + 'typing-single-advanced-lesson/'
export const typingCombineIntermediateLessonAPI = prefix + 'typing-combine-intermediate-lesson/'
export const typingCombineAdvancedLessonAPI = prefix + 'typing-combine-advanced-lesson/'
export const typingEssayRuleAPI = prefix + 'typing-essay-rule/'
export const typingEssayAPI = prefix + 'typing-essay'

export const submitTypingSingleBasicRecordAPI = prefix + 'typing-single-basic-record/'
export const submitTypingSingleIntermediateRecordAPI = prefix + 'typing-single-intermediate-record/'
export const submitTypingSingleAdvancedRecordAPI = prefix + 'typing-single-advanced-record/'
export const submitTypingCombineIntermediateRecordAPI = prefix + 'typing-combine-intermediate-record/'
export const submitTypingCombineAdvancedRecordAPI = prefix + 'typing-combine-advanced-record/'
export const submitTypingEssayPracticeRecordAPI = prefix + 'typing-essay-practice-record/'
export const submitTypingEssayTestRecordAPI = prefix + 'typing-essay-test-record/'

export const checkIfPassTypingSingleAdvancedLesson = prefix + 'typing-single-advanced-check-if-pass'
export const checkIfPassTypingCombineAdvancedLesson = prefix + 'typing-combine-advanced-check-if-pass'

export const typingSingleBasicHistoryAPI = prefix + 'typing-single-basic-record/'
export const typingSingleIntermediateHistoryAPI = prefix + 'typing-single-intermediate-record/'
export const typingSingleAdvancedHistoryAPI = prefix + 'typing-single-advanced-record/'
export const typingCombineIntermediateHistoryAPI = prefix + 'typing-combine-intermediate-record/'
export const typingCombineAdvancedHistoryAPI = prefix + 'typing-combine-advanced-record/'
export const typingEssayPracticeHistoryAPI = prefix + 'typing-essay-practice-record/'
export const typingEssayTestHistoryAPI = prefix + 'typing-essay-test-record/'
